module.exports = __webpack_public_path__ + "travelstaytion_ico.png?b1626f66adafa2991d6b8cb2ceaf4dc4";